module.exports = __webpack_public_path__ + "img/4.6842a494.png";